// Written in this round about way for babel-transform-imports
import Route from 'react-router/es/Route';

export default Route;


//////////////////
// WEBPACK FOOTER
// c:/jenkins/workspace/plesk-17.8/~/react-router-dom/es/Route.js
// module id = 21
// module chunks = 1 2 3 4 5